<div class="app-marker-info" >
  <div class="app-marker-info__title">
    {{data.name}}
  </div>
  <div class="app-marker-info__direction">
    {{data.direction}}
  </div>
  <div class="app-marker-info__content">
    <div class="app-marker-info__attributes">
      <img [src]="filter.iconactive" [alt]="filter.name" *ngFor="let filter of filters; index as i">
    </div>
  </div>
  
</div>
